<!-- created by arindyproject -->
<div v-if="videoUrl" class="video-container ">
    <iframe
      width="100%"
      height="400px"
      :src="videoUrl"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen>
    </iframe>
  </div>
  <div v-else>
    <p>No valid video URL provided.</p>
  </div>